import { render, staticRenderFns } from "./TermsPost.vue?vue&type=template&id=704f6b3e&"
import script from "./TermsPost.vue?vue&type=script&lang=js&"
export * from "./TermsPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports